jQuery(document).ready(function($) {

    $( ".bloc_bandeau" ).each(function( index ) {

        let bloc = this

        // Le bloc s'ouvre en largeur au scroll (clip-path symétrique) jusqu'à prendre toute la largeur
        gsap.fromTo(bloc,
            { clipPath: "inset(0% 2% 0% 2%)" },
            {
                clipPath: "inset(0% 0% 0% 0%)",
                ease: "none",
                scrollTrigger: {
                    trigger: bloc,
                    start: "top bottom",
                    end: "top 70%",
                    scrub: true
                }
            }
        )

    })

});
